import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { FeaturedSections } from '../components/FeaturedSections';
import { TrustIndex } from '../components/TrustIndex';
import { Footer } from '../components/Footer';
export function Home() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-453">
      <Header data-id="element-454" />
      <main data-id="element-455">
        <Hero data-id="element-456" />
        <motion.div initial={{
        y: 40,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-457">
          <FeaturedSections data-id="element-458" />
        </motion.div>
        <motion.div initial={{
        y: 40,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-459">
          <TrustIndex data-id="element-460" />
        </motion.div>
      </main>
      <Footer data-id="element-461" />
    </motion.div>;
}